import * as STD        from '@emersya/mpa-std-lib';
import { InputNumber } from '@emersya/mpa-components-lib';
import EngineModule    from '../EngineModule';
import {
	IPlannerDimensionsEditorComponentConfiguration
}                      from '../components/viewer/planner/DimensionsEditor/PlannerDimensionsEditor';

export default () => new EngineModule.UIEngineModule({
	type :             'ui',
	allowedCustomers : null,
	id :               'viewer-planner-dimensionsEditor',
	dependencies :     [
		'viewer-planner',
		'oms-basket'
	],
	modulesBefore :    [ 'product-editor', 'viewer-planner-layout-editor' ],
	modulesAfter :     [ 'viewer-planner-furniture-editor' ],
	usableCondition :  {
		type : 'and',
		LHS :  {
			type :      'notequal',
			component : 'K.basket',
			property :  'TARGET.basket.currentProduct',
			value :     null
		},
		RHS :  {
			type :      'notequal',
			component : 'K.basket',
			property :  '[*]TARGET.basket.currentProduct.getPart(["layout"]).currentOption',
			value :     null
		}
	},
	displayCondition : {
		type : 'or',
		LHS :  {
			type :      'equal',
			component : 'K',
			property :  '[*]TARGET.hasThisModuleUsed("standing-customerMode")',
			value :     false
		},
		RHS :  {
			type :      'notequal',
			component : 'K',
			property :  '[*]TARGET.parameters.mode',
			value :     'client'
		}
	},
	generateComponentConfiguration() {
		const config = this.configuration;
		if (!this.translations.width) {
			throw STD.errors.user('', { module : this });
		}
		if (!this.translations.depth) {
			throw STD.errors.user('', { module : this });
		}
		if (!this.translations.height) {
			throw STD.errors.user('', { module : this });
		}
		const out : IPlannerDimensionsEditorComponentConfiguration = {
			width :                  {
				min :     Number.parseFloat(config[ 'width-min' ]),
				max :     Number.parseFloat(config[ 'width-min' ]),
				default : Number.parseFloat(config[ 'width-min' ])
			},
			height :                 {
				min :     Number.parseFloat(config[ 'height-min' ]),
				max :     Number.parseFloat(config[ 'height-min' ]),
				default : Number.parseFloat(config[ 'height-min' ])
			},
			depth :                  {
				min :     Number.parseFloat(config[ 'depth-min' ]),
				max :     Number.parseFloat(config[ 'depth-min' ]),
				default : Number.parseFloat(config[ 'depth-min' ])
			},
			increment :              Number.parseFloat(config[ 'increment' ]),
			'@innerConfigurations' : {
				width :  {
					'@translations' :        {
						label : this.translations.width
					},
					'@innerConfigurations' : {
						range : <InputNumber.Configuration> {
							defaultValue :  Number.parseFloat(config[ 'width-default' ]),
							max :           Number.parseFloat(config[ 'width-max' ]),
							min :           Number.parseFloat(config[ 'width-min' ]),
							renderingMode : 'textual',
							step :          Number.parseFloat(config.increment)
						}
					}
				},
				depth :  {
					'@translations' :        {
						label : this.translations.depth
					},
					'@innerConfigurations' : {
						range : <InputNumber.Configuration> {
							defaultValue :  Number.parseFloat(config[ 'depth-default' ]),
							max :           Number.parseFloat(config[ 'depth-max' ]),
							min :           Number.parseFloat(config[ 'depth-min' ]),
							renderingMode : 'textual',
							step :          Number.parseFloat(config.increment)
						}
					}
				},
				height : {
					'@translations' :        {
						label : this.translations.height
					},
					'@innerConfigurations' : {
						range : <InputNumber.Configuration> {
							defaultValue :  Number.parseFloat(config[ 'height-default' ]),
							max :           Number.parseFloat(config[ 'height-max' ]),
							min :           Number.parseFloat(config[ 'height-min' ]),
							renderingMode : 'slider',
							step :          Number.parseFloat(config.increment)
						}
					}
				}
			},
		};
		return out;
	}
});
